import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  MomentAdminUpdateSetting,
  MomentsAdminSettingsUpdateSettingAction,
  MomentsAdminSettingsUpdateSettingRejectedAction,
} from '../../domains/momentsAdminSettings/actions.types';
import { MomentsLoadAdminSettingsAction } from '../../domains/momentsLoadAdminSettings/actions.types';

import { MomentsAdminSettingsLifecycle } from './types';

const initialState: MomentsAdminSettingsLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const updateFulfilledMomentsAdminSettingWithNewValue = (
  state: MomentsAdminSettingsLifecycle,
  payload: MomentAdminUpdateSetting
) => ({
  ...state,
  fulfilled: { ...state.fulfilled, [payload.settingProp]: payload.settingValue },
});

const updateFulfilledMomentsAdminSettingWithPreviousValue = (
  state: MomentsAdminSettingsLifecycle,
  payload: MomentsAdminSettingsUpdateSettingRejectedAction['payload']
) => ({
  ...state,
  fulfilled: { ...state.fulfilled, [payload.setting.settingProp]: payload.prevValue },
});

const reducer: Reducer<
  MomentsAdminSettingsLifecycle,
  MomentsAdminSettingsUpdateSettingAction | MomentsLoadAdminSettingsAction
> = (state = initialState, action) => {
  switch (action.type) {
    case 'MOMENTS_ADMIN_SETTINGS.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    case 'MOMENTS_ADMIN_SETTINGS.LOAD_PENDING':
      return setPending();
    case 'MOMENTS_ADMIN_SETTINGS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'MOMENTS_ADMIN_SETTINGS.UPDATE_SETTING_VALUE_PENDING':
      return updateFulfilledMomentsAdminSettingWithNewValue(state, action.payload);
    case 'MOMENTS_ADMIN_SETTINGS.UPDATE_SETTING_VALUE_REJECTED':
      return updateFulfilledMomentsAdminSettingWithPreviousValue(state, action.payload);
    case 'MOMENTS_ADMIN_SETTINGS.UPDATE_SETTING_VALUE_FULFILLED':
      return updateFulfilledMomentsAdminSettingWithNewValue(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
